"use client";

import React, { useState, useEffect, createContext, useContext } from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import ReactPlayerLazy from "@/components/ReactPlayerLazy";
import { useQueryState } from "nuqs";

export const VideoContext = createContext<any | null>(null);

export function VideoProvider({ children }: { children: React.ReactNode }) {
  const [video, setVideo] = useState<any | null>(null);
  return (
    <VideoContext.Provider value={{ video, setVideo }}>
      {children}
    </VideoContext.Provider>
  );
}

function VideoPlayer() {
  const [videoParam, setVideoParam] = useQueryState("video");

  const { video, setVideo } = useContext(VideoContext);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (videoParam) {
      setIsOpen(true);
      setVideo({
        url: videoParam,
      });
    } else {
      setIsOpen(false);
      setVideo(null);
    }
  }, [setVideo, videoParam]);

  const handleClose = () => {
    setIsOpen(false);
    setVideo(null);
    setTimeout(() => {
      setVideoParam(null);
    }, 100);
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) handleClose();
      }}
    >
      <DialogContent className="md:max-w-[1100px]">
        <DialogTitle className="sr-only">Play Video</DialogTitle>
        <div className="w-full aspect-[16/9]">
          {isOpen && video?.url ? (
            <ReactPlayerLazy
              src={video.url}
              width="100%"
              height="100%"
              controls
              playing={true}
            />
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default VideoPlayer;
